import { useState, type ReactNode } from 'react';
import { Button } from './Button';
import { Field, Textarea } from './Form';
import { Modal } from './Modal';

interface Props {
  open: boolean;
  title: string;
  message?: ReactNode;
  confirmLabel?: string;
  tone?: 'primary' | 'danger' | 'success';
  /** Ask for a reason (required when `reasonRequired`). */
  withReason?: boolean;
  reasonRequired?: boolean;
  reasonLabel?: string;
  loading?: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}

export function ConfirmDialog({ open, title, message, confirmLabel = 'تأكيد', tone = 'primary', withReason, reasonRequired, reasonLabel = 'السبب', loading, onConfirm, onClose }: Props) {
  const [reason, setReason] = useState('');
  const invalid = reasonRequired && reason.trim().length < 3;
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      footer={
        <>
          <Button onClick={onClose}>إلغاء</Button>
          <Button variant={tone} loading={loading} disabled={invalid} onClick={() => onConfirm(reason.trim())}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {message && <div className="mb-3 text-sm leading-7 text-ink">{message}</div>}
      {withReason && (
        <Field label={reasonLabel}>
          <Textarea value={reason} onChange={(e) => setReason(e.target.value)} autoFocus />
        </Field>
      )}
    </Modal>
  );
}
